import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CadastrosNotaProps } from './types';
import NotaModal from '../../../components/Cadastros/Notas/NotaModal';
import * as S from './styles';
import Table from '../../../components/interface/Tabela';
import { DateInput } from '../../../components/interface/DateInput';

const CadastrosNota: React.FC<CadastrosNotaProps> = ({
  selectedDate,
  error,
  notas,
  formData,
  entregadores,
  isModalOpen,
  handleDateChange,
  handleOpenModal,
  handleCloseModal,
  handleSubmit,
  handleChange,
  handleCancelarNota,
}) => {
  return (
    <S.Container>
      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}
      <S.HeaderContainer>
        <S.DateContainer>
          <S.DateField>
            <DateInput
              initialValue={selectedDate}
              setValue={handleDateChange}
              id="data"
              hasLabel={true}
              labelPosition="left"
              label="Data"
              required={true}
            />
          </S.DateField>
        </S.DateContainer>
        <S.AddButton onClick={() => handleOpenModal()}>
          <FontAwesomeIcon icon={faPlus} />
        </S.AddButton>
      </S.HeaderContainer>

      <Table
        data={notas}
        columns={[
          {
            key: 'chaveNota',
            header: 'Chave/Código',
            filterable: true,
          },
          {
            key: 'entregador',
            header: 'Entregador',
            filterable: true,
          },
          {
            key: 'actions',
            header: 'Excluir',
            width: '80px',
            td: (nota) => (
              <S.DeleteTableButton
                onClick={() => handleCancelarNota(nota)}
                title="Excluir nota"
              >
                <FontAwesomeIcon icon={faTrash} />
              </S.DeleteTableButton>
            ),
          },
        ]}
        exportable={true}
      />

      <NotaModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        formData={formData}
        entregadores={entregadores}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </S.Container>
  );
};

export default CadastrosNota;
